import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { SharedHero } from '@hover/shared-components';
import { Layout, UtilityMenuBanner } from '../../v2/components/common';

import {
  CaseStudy,
  Info,
  TransformBusiness,
} from '../../v2/components/prosNewConstruction';
import { URLS } from '../../v2/constants';
import { usePageViewTracking } from '../../utils/trackPageView';
import FacebookPixel from '../../v2/components/common/layout/FacebookPixel';

const NewConstructionSolution: React.FC = () => {
  usePageViewTracking('new-construction-solution');
  return (
    <Layout
      title="Exterior Home Improvement Software For Home Builders"
      description="Use HOVER for new construction jobs The fastest, simplest way to get measurements and prepare standout bids from blueprints."
      buttonType="SCHEDULE_A_DEMO"
      bannerElement={<UtilityMenuBanner />}
    >
      <FacebookPixel />
      <SharedHero
        heading="Use HOVER for new construction jobs"
        body="The fastest, simplest way to get measurements and prepare standout bids from blueprints. Turn it on for your account today."
        chatWithUsLink={URLS.newConstructionSolution.chatWithUs}
        openModalButtonTitle="TRY IT NOW"
        openModalButtonLink={URLS.newConstructionSolution.tryItNow}
        onOpenModalClick={() => {
          // eslint-disable-next-line
          window.fbq('trackCustom', 'New_Construction_CTA_click');
        }}
        desktopImage={
          <StaticImage
            loading="eager"
            placeholder="blurred"
            alt="invited by contractor hero"
            src="../../v2/assets/images/new_construction_solution_hero_desktop.png"
          />
        }
        mobileAndTabletImage={
          <StaticImage
            loading="eager"
            placeholder="blurred"
            alt="invited by contractor hero"
            src="../../v2/assets/images/new_construction_solution_hero_tablet.png"
          />
        }
        page="new-construction-solution"
      />

      <Info />
      <CaseStudy />
      <TransformBusiness />
    </Layout>
  );
};

export default NewConstructionSolution;
